export default "__VITE_ASSET__bbe51d03__"